import type { FButtonMenuOption } from '../../baseV2';
import type { TabbedPageTabConfig, TabbedPageTabDecoration } from './types';

export function buildTabOptions<TTabId extends string = string>(
  tabConfigs: ReadonlyArray<TabbedPageTabConfig<TTabId>>,
  basePath: string,
  decorate?: (tabId: TTabId) => TabbedPageTabDecoration | undefined,
): ReadonlyArray<FButtonMenuOption> {
  return tabConfigs.map((tabConfig) => {
    const decoration = decorate?.(tabConfig.id);
    return {
      value: tabConfig.id,
      label: tabConfig.label,
      to: `${basePath}/${tabConfig.id}`,
      error: decoration?.error ?? false,
      success: decoration?.success ?? false,
    };
  });
}
